import { useQuery } from '@apollo/client';
import { isFunction } from 'lodash';
import React, { memo, useState } from 'react';
import client from 'api/environment';
import AUTOCOMPLETE_USERS from 'api/queries/AUTOCOMPLETE_USERS';
import Avatar from 'layout/atoms/Avatar/Avatar';
import Button from 'layout/atoms/Button/Button';
import env from 'utils/env';
import './InvitationSender.scss';
function InvitationSender({ followers = [], selectOne = false, onSelectUser, onClose, currentUserId, }) {
    var _a, _b, _c;
    const [selectedUsers, setSelectedUsers] = useState(followers === null || followers === void 0 ? void 0 : followers.map(({ id }) => id));
    const { data } = useQuery(AUTOCOMPLETE_USERS, { client });
    const allUsers = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.autocomplete) === null || _a === void 0 ? void 0 : _a.users) === null || _b === void 0 ? void 0 : _b.edges) === null || _c === void 0 ? void 0 : _c.map(({ node }) => node);
    const users = currentUserId ? allUsers === null || allUsers === void 0 ? void 0 : allUsers.filter((user) => user.id !== currentUserId) : allUsers;
    const handleSelectUser = (userId) => () => {
        const isSelected = selectedUsers === null || selectedUsers === void 0 ? void 0 : selectedUsers.includes(userId);
        if (selectOne && isSelected) {
            setSelectedUsers([]);
            return;
        }
        if (selectOne && !isSelected) {
            setSelectedUsers([userId]);
            return;
        }
        if (isSelected) {
            setSelectedUsers(selectedUsers === null || selectedUsers === void 0 ? void 0 : selectedUsers.filter((id) => id !== userId));
        }
        else {
            setSelectedUsers([...selectedUsers, userId]);
        }
        if (isFunction(onSelectUser)) {
            onSelectUser(users === null || users === void 0 ? void 0 : users.find(({ id }) => id === userId), !isSelected);
            if (isFunction(onClose))
                onClose();
        }
    };
    return (React.createElement("div", { className: "InvitationSender" },
        React.createElement("ul", { className: "InvitationSender__wrapper" }, users === null || users === void 0 ? void 0 : users.map((user) => {
            const isSelected = selectedUsers.includes(user.id);
            return (React.createElement(Button, { key: user.id, display: "block", align: "left", theme: isSelected ? 'fill' : 'ghost', onClick: handleSelectUser(user.id), leftIcon: React.createElement(Avatar, { size: "s", userName: user === null || user === void 0 ? void 0 : user.username, src: (user === null || user === void 0 ? void 0 : user.avatar) ? `${env.static}/${user.avatar}` : null }) }, user === null || user === void 0 ? void 0 : user.username));
        }))));
}
export default memo(InvitationSender);
